// Dashboard Action Types

// Get Dashboard Data
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GET_DASHBOARD_DATA_SUCCESS = "GET_DASHBOARD_DATA_SUCCESS";
export const GET_DASHBOARD_DATA_ERROR = "GET_DASHBOARD_DATA_ERROR";

// Dashboard Activity
export const GET_DASHBOARD_ACTIVITY_LIST = "GET_DASHBOARD_ACTIVITY_LIST";
export const GET_DASHBOARD_ACTIVITY_LIST_SUCCESS =
  "GET_DASHBOARD_ACTIVITY_LIST_SUCCESS";
export const GET_DASHBOARD_ACTIVITY_LIST_FAIL =
  "GET_DASHBOARD_ACTIVITY_LIST_FAIL";
